/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Form, Row, Select,
  Tag,
} from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { FormItem, FormSelect } from '../../../components';

const VehicleSection = ({
  field, form, companies, companyVehicles,
}) => {
  const { t } = useTranslation();
  const trackingTimeframeHasEnded = Form.useWatch(['vehicles', field.key, 'trackingTimeframeHasEnded'], form);

  return (
    <Row>
      <FormItem
        name={[field.name, 'id']}
        rules={[{ required: true, message: t('ORDER.VEHICLES_MISSING') }]}
      >
        <FormSelect
          loading={companies.loading}
          showSearch
          disabled={!form.getFieldValue('carrierCompanyId') || trackingTimeframeHasEnded}
          optionFilterProp="children"
          filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
        >
          {companyVehicles.map(({
            vehicleId, licencePlateNumber,
          }) => <Select.Option key={vehicleId} value={vehicleId}>{licencePlateNumber}</Select.Option>)}
        </FormSelect>
      </FormItem>
      {trackingTimeframeHasEnded && (
        <div>
          <Tag color="orange" icon={<WarningOutlined />}>
            {t('ORDER.TIMEFRAME_ENDED')}
          </Tag>
        </div>
      )}
    </Row>
  );
};

VehicleSection.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    key: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }).isRequired,
  form: PropTypes.shape({
    getFieldValue: PropTypes.func,
  }).isRequired,
  companies: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({
      companyId: PropTypes.string.isRequired,
      companyName: PropTypes.string.isRequired,
    })),
    loading: PropTypes.bool.isRequired,
  }).isRequired,
  companyVehicles: PropTypes.arrayOf(PropTypes.shape({
    vehicleId: PropTypes.string.isRequired,
    licencePlateNumber: PropTypes.string.isRequired,
  })).isRequired,
};

VehicleSection.defaultProps = {
};

export default VehicleSection;
